export default __webpack_public_path__ + "static/media/bg.baa2fe00.jpg";